<template>
  <section>
    <bread-crumb></bread-crumb>
    <service-info :detail-info="detailInfo"></service-info>
    <div class="componet-wrap">
      <div class="left-componet">
        <contact-info :detail-info="detailInfo"></contact-info>
        <screen-shot-info title="截图信息" :detail-info="detailInfo"></screen-shot-info>
        <screen-shot-info title="补充信息" :detail-info="detailInfo" v-if="detailInfo.order_supplement_img && detailInfo.order_supplement_img.length"></screen-shot-info>
      </div>
      <protocol-info class="right-componet">
        <div class="btn-text">
          <!-- <span>您已参与充3000送400，实际支付156元</span> -->
          <div>
            <button class="submit" @click="submit">提交</button>
            <button class="back" @click="$router.go(-1)">返回</button>
          </div>
        </div>
      </protocol-info>
    </div>

    <!-- 支付成功弹框 -->
    <pay-success-modal v-if="isSuccess" :charge-money="chargeMoney" :order_uuid="order_uuid" type="pay"></pay-success-modal>

    <pay-modal @close="close" @getCallBack="getCallBack" v-if="isPayModal" :charge-money="chargeMoney" :order_uuid="order_uuid" :order_member_price="order_member_price" type="pay" ref="payModal"></pay-modal>
  </section>
</template>

<script>
import BreadCrumb from '@/components/BreadCrumb.vue';
import serviceInfo from './components/serviceInfo.vue'
import contactInfo from './components/contactInfo.vue'
import screenShotInfo from './components/screenShotInfo.vue'
import protocolInfo from './components/protocolInfo.vue'
import payModal from '@/components/payModal';
import paySuccessModal from '@/components/paySuccessModal';
import {getOrderDetail, getOrderPay, getSalesman, placeOrderAdmin, getCommission} from '@/api/order'
import utils from '@/assets/js/utils'
export default {

  components: {
	    BreadCrumb,
    serviceInfo,
    contactInfo,
    screenShotInfo,
    protocolInfo,
    payModal,
    paySuccessModal
  },
  data() {
    	return {
      order_uuid: this.$route.query.order_uuid,
      detailInfo: {
        server_info: {}
      },
      isPayModal: false,
      chargeMoney: '',
	  order_member_price: '',
	  isSuccess: false
    };
  },

  created() {
    this.getOrderDetail()
  },

  methods: {
    // 获取订单详情
    async getOrderDetail() {
      const { data, status } = await getOrderDetail(this.order_uuid);
      if (status == 200) {
        this.detailInfo = data;
        this.detailInfo.after_sale_name = utils.typeToName(this.detailInfo.after_sale_type);
        this.detailInfo.question_url = this.detailInfo.question_url.split(',');
      }
    },

    // 立即支付
    submit() {
      this.isPayModal = true;
      this.chargeMoney = this.detailInfo.order_total_price;
	  this.order_member_price = this.detailInfo.order_member_price
	  this.$nextTick(() => {
	    this.$refs.payModal.payClick(1);
	  })
    },

    // 支付成功的回调
    getCallBack() {
	  this.$nextTick(() => {
	    this.isSuccess = true;
	  })
    },

    close() {
      this.isPayModal = false;
    },
  }
};
</script>

<style lang="scss" scoped>
    .componet-wrap{
        display: flex;
        justify-content: space-between;
		.left-componet{
			width: 54%;
		}
		.right-componet{
			width: 44%;
		}
    }
	.btn-text{
        span{
            font-size: 16px;
            @include font-style;
            color: #FF8E1C;
        }
        div{
            margin-top: 22px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            button{
                height: 60px;
                line-height: 60px;
                text-align: center;
                border-radius: 5px;
                font-size: 20px;
            }
            .submit{
                width:58%;
                background: #FF8E1C;
                box-shadow: 1px 8px 10px 1px rgba(32, 56, 118, 0.08);
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
                @include cursor-style
            }
            .back{
                width: 38%;
                background: #FFFFFF;
                border: 1px solid #9A9A9A;
                box-shadow: 1px 8px 10px 1px rgba(32, 56, 118, 0.08);
                @include font-style;
                color: #9A9A9A;
                @include cursor-style
            }
        }
    }
</style>